export default __webpack_public_path__ + "static/media/CalendarSelected.3fc5cc8d.svg";